module.exports = __webpack_public_path__ + "img/bx-class-choosing-report-active.1df40374.svg";